/**
 * 药房域模块路由配置（门诊药房 / 住院药房）
 *
 * @module pharmacy/routes
 */
import { RouteRecordRaw } from "vue-router";

const PharmacyWorkbenchView = () =>
  import("./interfaces/PharmacyWorkbenchView.vue");
const InpatientPharmacyView = () =>
  import("./interfaces/InpatientPharmacyView.vue");

export const pharmacyRoutes: RouteRecordRaw[] = [
  {
    path: "/pharmacy-ops",
    name: "PharmacyWorkbench",
    component: PharmacyWorkbenchView,
    meta: {
      title: "门诊药房工作站",
      requiresAuth: true,
      keepAlive: true,
      breadcrumb: ["首页", "门诊药房工作站"],
    },
  },
  {
    // 住院药房岗位站（P3）：摆药/发药/退药 + 静配中心 + 药房库存
    path: "/inpatient-pharmacy",
    name: "InpatientPharmacyWorkbench",
    component: InpatientPharmacyView,
    meta: {
      title: "住院药房工作站",
      requiresAuth: true,
      keepAlive: false,
      breadcrumb: ["首页", "住院药房工作站"],
    },
  },
];

export default pharmacyRoutes;
